import api from '../httpClient';
import type { CourseCompletionData, CourseProgressData } from '../../types';

interface GetFlowByNameOptions {
  courseId?: number | null;
}

export const courses = {
  getAll: () => api.get('/api/courses/'),
  get: (id: number) => api.get(`/api/courses/${id}/`),
  getFlows: (id: number) => api.get(`/api/courses/${id}/flows/`),
  getFlowByName: (flowName: string, options: GetFlowByNameOptions = {}) => {
    const params =
      typeof options.courseId === 'number' && Number.isFinite(options.courseId)
        ? { course_id: options.courseId }
        : undefined;
    return api.get(`/api/courses/flow/${encodeURIComponent(flowName)}/`, { params });
  },
  getCourseProgress: (courseId: number) =>
    api.get<CourseProgressData>(`/api/courses/${courseId}/progress/`),
  getCourseCompletion: (courseId: number) =>
    api.get<CourseCompletionData>(`/api/courses/${courseId}/completion/`),
  getOrganizationCourseCompletion: (
    organizationId?: string,
    courseId?: string,
    page: number = 1,
    pageSize: number = 5,
  ) => {
    const params = new URLSearchParams();
    if (organizationId) params.append('organization_id', organizationId);
    if (courseId) params.append('course_id', courseId);
    params.append('page', page.toString());
    params.append('page_size', pageSize.toString());

    return api
      .get('/api/admin/organization-course-completion/', { params })
      .then((response) => response.data);
  },
  getLifePlanCompletionStats: (organizationId?: string) => {
    const params = organizationId ? { organization_id: organizationId } : {};
    return api
      .get('/api/admin/life-plan-completion-stats/', { params })
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error fetching life plan completion stats:', error);
        throw error;
      });
  },
  getUserPaceStats: (organizationId?: string) => {
    const params = organizationId ? { organization_id: organizationId } : {};
    return api
      .get('/api/admin/user-pace-stats/', { params })
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error fetching user pace stats:', error);
        throw error;
      });
  },
};
